export default __webpack_public_path__ + "static/media/user-feed4.37d3aecd.png";